const setLocalStorageItemWithExpiration = (key, value, ttl) => {
  const now = new Date();

  const item = {
    value,
    expiry: now.getTime() + ttl,
  };

  localStorage.setItem(key, JSON.stringify(item));
};

const clearLocalStorageItemWithExpiration = (key) => {
  localStorage.removeItem(key);
};

const getLocalStorageItemWithExpiration = (key) => {
  const itemStr = localStorage.getItem(key);
  // if the item doesn't exist, return null
  if (!itemStr) {
    return null;
  }

  try {
    const item = JSON.parse(itemStr);
    const now = new Date();
    // compare the expiry time of the item with the current time
    if (now.getTime() > item.expiry) {
    // If the item is expired, delete the item from storage
    // and return null
      clearLocalStorageItemWithExpiration(key);
      return null;
    }
    return item.value;
  } catch (error) {
    return null;
  }
};

export {
  setLocalStorageItemWithExpiration,
  getLocalStorageItemWithExpiration,
  clearLocalStorageItemWithExpiration,
};
